import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const thunkMiddleware = applyMiddleware(thunk);
const middleware = composeWithDevTools(thunkMiddleware);
export default createStore(rootReducer, middleware);
